import {apiClient} from '@common/http/query-client';
import {useQuery} from '@tanstack/react-query';

export const useGetSingleWatch = (titleId: number) => {
  return useQuery({
    queryKey: ['watched-signle-content'],
    queryFn: () => getSingleWatch(titleId),
    refetchOnWindowFocus: false,
  });
};

const getSingleWatch = (titleId: number) => {
  return apiClient.get(`stream/data/${titleId}`).then(r => r.data);
};
